import { flagFactory } from '../icon';
import Svg from './mt.svg';

export default flagFactory(Svg);
